import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import "firebase/performance";

const firebaseConfig = {
  apiKey: "AIzaSyDe2ndj8VeDoFtWsFxg-100W4VGx_4_hg8",
  authDomain: "uob-ee-registration.firebaseapp.com",
  projectId: "uob-ee-registration",
  storageBucket: "uob-ee-registration.appspot.com",
  messagingSenderId: "758743800471",
  appId: "1:758743800471:web:d155d302aaea2440ed27d2"
};

// init firebase
firebase.initializeApp(firebaseConfig)

// init services
const projectFirestore = firebase.firestore()
const projectAuth = firebase.auth()

// timestamp
const timestamp = firebase.firestore.Timestamp

// Initialize Performance Monitoring and get a reference to the service
const perf = firebase.performance();

export { projectFirestore, projectAuth, timestamp }